var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorToaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.069,
    height: 24.528,
    viewBox: "0 0 28.069 24.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error_toaster",
    transform: "translate(-1.467 -2.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10174",
    "data-name": "Path 10174",
    d: "M12,9v5.2",
    transform: "translate(3.501 2.567)",
    fill: "none",
    stroke: "#de3c34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10175",
    "data-name": "Path 10175",
    d: "M12.873,3.868,2.334,21.464A2.488,2.488,0,0,0,4.461,25.2h21.08a2.488,2.488,0,0,0,2.127-3.731L17.129,3.867a2.488,2.488,0,0,0-4.257,0Z",
    transform: "translate(0.5 0.667)",
    fill: "none",
    stroke: "#de3c34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10176",
    "data-name": "Path 10176",
    d: "M12,16h.013",
    transform: "translate(3.501 4.668)",
    fill: "none",
    stroke: "#de3c34",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToaster);
export default __webpack_public_path__ + "static/media/error_toaster.d35765ce17f6b995be39e817755902cc.svg";
export { ForwardRef as ReactComponent };